import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_info_bar()
})

$(window).on('scroll', function () {
  dhsv_vc_info_bar()
})

function dhsv_vc_info_bar() {
  let scrollTop = $(document).scrollTop(),
    triggerPoint = scrollTop + window.innerHeight / 2

  $('.dhsv_vc_info_bar').each(function () {
    let offsetTop = $(this).offset().top,
      $bars = $(this).find('.js-animated-bar')

    if (triggerPoint >= offsetTop && !$(this).hasClass('animated')) {
      $(this).addClass('animated')
      $bars.each(function () {
        let width = $(this).attr('data-width')
        $(this).animate({ width: width + '%' }, 500)
      })
    }
  })
}
